import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { DashboardSummaryResponse } from "@idw-types/data/dashboard";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

export const getDashboardSummaryRequest = async (
    companyId: string,
    startDate: string,
    endDate: string,
    timeZone: string,
    dateFormat: string
): Promise<GenericNetworkResponse<DashboardSummaryResponse>> => {
    const route = apiRoutes.reports.dashboard.summary;
    const queryParameters: Array<QueryParameter> = [];

    if (companyId) {
        queryParameters.push({ parameter: "companyIDs", value: companyId });
    }
    if (startDate) {
        queryParameters.push({ parameter: "startDate", value: startDate });
    }
    if (endDate) {
        queryParameters.push({ parameter: "endDate", value: endDate });
    }
    if (timeZone) {
        queryParameters.push({ parameter: "timeZone", value: timeZone });
    }

    queryParameters.push({ parameter: "dateFormat", value: dateFormat });

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};